module.exports = "https://web-assets.ifttt.com/packs/media/plan-badges/standard-955ae863.svg";